import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';

import { siteUrlsSelector } from '../../selectors/SiteUrlsSelectors';
import { AppState } from '../../state/AppState';
import { GroupSubspaceName } from '../../state/SpaceInfo';
import { MapStateToProps } from '../../utils/ConnectUtils';
import { RouterError } from '../RouterHelpers/RouterError';
import { SpacesSiteUrls } from '../SpacesSiteUrls';
import { GroupSpaceProvider, GroupSpaceProviderProps } from './GroupSpaceProvider';

export interface SpaceRouteParams {
  readonly id: string;
}

export interface GroupRouteComponentProps extends RouteComponentProps<SpaceRouteParams> {}

export interface GroupSpaceRouterOwnProps {
  readonly siteName: string;}

export interface GroupSpaceRouterStateProps {
  readonly urls: SpacesSiteUrls;
  readonly routerReactKey: number;
}

export type GroupSpaceRouterProps = GroupSpaceRouterOwnProps & GroupSpaceRouterStateProps;

export class GroupSpaceRouterComponent extends React.PureComponent<GroupSpaceRouterProps> {

  public render() {
    return (
      <Switch>
        <Route exact path={this.props.urls.groupUsersPath(':id')} render={this.provider('users')} />
        <Route exact path={this.props.urls.groupDetailsPath(':id')} render={this.provider('details')} />
        <Route exact path={this.props.urls.groupPath(':id')} render={({ match }) => (
          <Redirect to={this.props.urls.groupUsersPath(match.params.id)} />
        )} />
        <Route render={this.error} />
      </Switch>
    );
  }

  private provider = (subspaceName: GroupSubspaceName): (props: RouteComponentProps) => JSX.Element => {
    return (props: GroupRouteComponentProps): JSX.Element => {
      const groupSpaceProps: GroupSpaceProviderProps = {
        urls: this.props.urls,
        siteName: this.props.siteName,
        subspaceName,
        routeLocationSearch: props.location.search,
        routeLocationPath: null,
        groupId: props.match.params.id
      };

      return <GroupSpaceProvider {...groupSpaceProps}/>;
    };
  }

  private error = (_props: RouteComponentProps): JSX.Element => {
    return <RouterError errorType={'default'} urls={this.props.urls}/>;
  }
}

const mapStateToProps: MapStateToProps<GroupSpaceRouterStateProps> = (state: AppState) => ({
  urls: siteUrlsSelector(state),
  routerReactKey: state.routerSpaceReactKey
});

export const GroupSpaceRouter: React.ComponentClass<GroupSpaceRouterOwnProps>
  = connect(mapStateToProps)(GroupSpaceRouterComponent);
